import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockOutlined, MailOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { ADMIN_LOGIN_URL } from "../../constants/api";
import useApiMethods from "../../lib/useApiMethods";
import ToastMsg from "../../components/common/ToastMsg";

const AdminLogin = () => {
    const navigate = useNavigate();
    const { create } = useApiMethods();
    const [loading, setLoading]   = useState(false);
    const [showPwd, setShowPwd]   = useState(false);
    const [form, setForm]         = useState({ email: "", password: "" });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.email || !form.password) {
            ToastMsg("error", "Email and password required");
            return;
        }
        const res = await create(ADMIN_LOGIN_URL, form, false, setLoading);
        if (res?.status === "success") {
            sessionStorage.setItem("admin_token", res.data.token);
            sessionStorage.setItem("admin_name",  res.data.name);
            navigate("/admin/dashboard");
        } else {
            ToastMsg("error", res?.message || "Login failed");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 p-4">
            <div className="w-full max-w-md">
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-8">
                    {/* Header */}
                    <div className="text-center mb-8">
                        <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                            <LockOutlined className="text-white text-2xl" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Onboarding Portal</h1>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Internal team access only</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* Email */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Email</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <MailOutlined className="text-gray-400" />
                                </div>
                                <input
                                    type="email" name="email" value={form.email} onChange={handleChange} required
                                    placeholder="team@yourcompany.com"
                                    className="w-full pl-10 pr-4 py-3 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Password</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <LockOutlined className="text-gray-400" />
                                </div>
                                <input
                                    type={showPwd ? "text" : "password"} name="password" value={form.password} onChange={handleChange} required
                                    placeholder="Enter your password"
                                    className="w-full pl-10 pr-10 py-3 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                />
                                <button type="button" onClick={() => setShowPwd(p => !p)}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
                                    {showPwd ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                </button>
                            </div>
                        </div>

                        <button type="submit" disabled={loading}
                            className="w-full py-3 rounded-xl font-semibold text-white bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 transition-colors">
                            {loading ? "Signing in…" : "Sign In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
